import styled from 'styled-components';

export const Link = styled.a`
  padding: 1rem;
`;

export const Image = styled.img`
  width: 100%;
`;
